import React from "react";

export default function Heading({ userQuery, handleQuery, handleSubmit }) {
  return (
    <div className="heading-container">
      <h1>Black Market Market</h1>
      <h2>Best deals on the web for your specific nuclear needs.</h2>
    </div>
  );
}
